



































































import { Component, Vue } from "vue-property-decorator";

import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import FileUploadMulti from "@/components/files/FileUploadMulti.vue";

import { AssetEnum } from "@/lib/AssetRepository";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";

import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { ReportModule } from "@/store/modules/report.store";

@Component({
  components: {
    LayoutReportStep,
    FileUploadMulti
  }
})
export default class ReportImageOverview extends Vue implements IReportStep {
  multiSteps = {
    frontLeft: {
      example: AssetEnum.carFrontLeft,
      overlay: AssetEnum.carFrontLeftOutline,
      text: "report.imageOverview.frontLeftText",
      textAlt: "report.imageOverview.frontLeftTextAlt",
      filesCb: ReportModule.overviewsFrontLeft,
      handleUpload: ReportModule.addOverviewFrontLeft,
      handleDelete: ReportModule.removeOverviewFrontLeft
    },
    rearLeft: {
      example: AssetEnum.carRearLeft,
      overlay: AssetEnum.carRearLeftOutline,
      text: "report.imageOverview.rearLeftText",
      textAlt: "report.imageOverview.rearLeftTextAlt",
      filesCb: ReportModule.overviewsRearLeft,
      handleUpload: ReportModule.addOverviewRearLeft,
      handleDelete: ReportModule.removeOverviewRearLeft
    },
    rearRight: {
      example: AssetEnum.carRearRight,
      overlay: AssetEnum.carRearRightOutline,
      text: "report.imageOverview.rearRightText",
      textAlt: "report.imageOverview.rearRightTextAlt",
      filesCb: ReportModule.overviewsRearRight,
      handleUpload: ReportModule.addOverviewRearRight,
      handleDelete: ReportModule.removeOverviewRearRight
    },
    frontRight: {
      example: AssetEnum.carFrontRight,
      overlay: AssetEnum.carFrontRightOutline,
      text: "report.imageOverview.frontRightText",
      textAlt: "report.imageOverview.frontRightTextAlt",
      filesCb: ReportModule.overviewsFrontRight,
      handleUpload: ReportModule.addOverviewFrontRight,
      handleDelete: ReportModule.removeOverviewFrontRight
    }
  };

  get getOverviewFrontLeft() {
    return ReportModule.overviewsFrontLeft;
  }

  get getOverviewFrontRight() {
    return ReportModule.overviewsFrontRight;
  }

  get getOverviewRearLeft() {
    return ReportModule.overviewsRearLeft;
  }

  get getOverviewRearRight() {
    return ReportModule.overviewsRearRight;
  }

  header: IReportHeaderData = {
    title: "report.imageOverview.title",
    description: "report.imageOverview.description",
    image: AssetEnum.overview
  };

  instruction: IReportInstructionData = {
    title: "report.imageOverview.title",
    text: "report.imageOverview.instructionText",
    pictures: [AssetEnum.damageOverviewFrontInstruction, AssetEnum.damageOverviewBehindInstruction],
    example: AssetEnum.damageInstruction,
    display: true
  };

  /**
   * @inheritdoc
   */
  get isDone(): boolean {
    if (this.getOverviewFrontLeft.length <= 0) {
      return false;
    }

    if (this.getOverviewFrontRight.length <= 0) {
      return false;
    }

    if (this.getOverviewRearLeft.length <= 0) {
      return false;
    }

    if (this.getOverviewRearRight.length <= 0) {
      return false;
    }

    return true;
  }
}
